export const environment = {
  apiMenuUrl: 'https://omo-lavanderias-dev-back-menus-4df2kcmewq-uc.a.run.app',
  apiUsersUrl: 'https://omo-lavanderias-dev-back-users-4df2kcmewq-uc.a.run.app',
  apiOrderUrl:
    'https://omo-lavanderias-dev-back-orders-4df2kcmewq-uc.a.run.app',
  mapServiceUrl: 'https://map-service-4df2kcmewq-uc.a.run.app/maps',
};
